module.exports = require("./fr-MG.d.ts");